export default __webpack_public_path__ + "static/media/shared_icon.71f9e688.svg";